import CollageDesignerControlPanel from './CollageDesignerControlPanel';

export default CollageDesignerControlPanel;
